import VueVirtualWaterfall from "@lhlyu/vue-virtual-waterfall";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueVirtualWaterfall);
});
